import { FadeIn } from './AnimatedSection';

export default function PageHeader({ title, subtitle, imagePath }: { title: string, subtitle: string, imagePath: string }) {
  return (
    <div className="relative h-[50vh] min-h-[400px] flex items-center justify-center overflow-hidden">
      <div 
        className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat transition-transform duration-[15s] ease-out hover:scale-105"
        style={{ backgroundImage: `url("${imagePath}")` }}
      >
        <div className="absolute inset-0 bg-black-deep/70"></div>
      </div>

      <FadeIn className="relative z-10 text-center px-4 max-w-4xl mx-auto mt-20">
        <span className="text-gold-400 font-script text-2xl md:text-3xl mb-4 block tracking-wide">
          {subtitle}
        </span>
        <h1 className="text-4xl md:text-6xl font-serif text-white leading-tight drop-shadow-lg">
          {title}
        </h1>
      </FadeIn>
    </div>
  );
}
